<template>
  <div class="content-page pb-5 h-100 ">
    <div class="scroll-area1">
      <div class="p-a-5">
        <div class="content-body p-2 bg-white d-flex align-items-center mb-2">
          <v-form class="w-100">
            <v-row class="ptb-0 sm-gutters">
              <v-col sm="3">
                <label class="inputs-lbl mb-1" for="company">Candidates #</label>
                <div class="d-flex align-items-center input-mb-0">
                  <v-text-field class="form-input"></v-text-field>
                  <button class="btn btn-transparent p-1"><img src="../../../static/images/search.png" class="w-14" /></button>
                </div>
              </v-col>
              <v-col sm="4">
                <label class="inputs-lbl mb-1" for="company">Applied for</label>
                <v-text-field class="form-input"></v-text-field>
              </v-col>
              <v-col sm="5" class="justify-content-end d-flex">
                <div class="d-flex align-items-center mr-3">
                  <img src="../../../static/images/user-photo.png" class="intervier-pics w-56 mr-2" />
                  <div class="intervier-name">FAN BING BING</div>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </div>
        <div class="content-body ">
          <div class="table-left-col">
            <div>
              <div class="left-blank-space date-header" style="width:60%; margin-left:40%;">2020/10/13</div>
            </div>
            <v-simple-table class="table table-sm mb-0 table-striped interview-table">
              <template>
                <thead>
                  <tr>
                    <th width="40%">
                      Criteria
                    </th>
                    <th width="10%" class="text-center">
                      Exe
                    </th>
                    <th width="10%" class="text-center">
                      Good
                    </th>
                    <th width="10%" class="text-center">
                      Sat
                    </th>
                    <th width="10%" class="text-center">
                      Fair
                    </th>
                    <th width="10%" class="text-center">
                      Poor
                    </th>
                    <th width="10%" class="text-center">
                      N/A
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td width="40%">LANG</td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details checked></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                  </tr>
                  <tr>
                    <td width="40%">LANG</td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details checked></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                  </tr>
                  <tr>
                    <td width="40%">LANG</td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details checked></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                  </tr>
                  <tr>
                    <td width="40%">LANG</td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details checked></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                  </tr>
                  <tr>
                    <td width="40%">LANG</td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details checked></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                  </tr>
                  <tr>
                    <td width="40%">LANG</td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details checked></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                  </tr>
                  <tr>
                    <td width="40%">LANG</td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details checked></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                  </tr>
                  <tr>
                    <td width="40%">LANG</td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details checked></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                  </tr>
                  <tr>
                    <td width="40%">LANG</td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details checked></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                  </tr>
                  <tr>
                    <td width="40%">LANG</td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details checked></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                  </tr>
                  <tr>
                    <td width="40%">LANG</td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details checked></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                  </tr>
                  <tr>
                    <td width="40%">LANG</td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details checked></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                    <td width="10%">
                      <v-checkbox class="table-checkbox m-0 p-0"
                                  color="indigo darken-3"
                                  value="indigo darken-3"
                                  hide-details></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <div class="border-box mt-2 d-inline-block">
              <div style="width:40%;float:left;">
                <div class="box-header d-flex justify-content-between align-items-center">
                  <div class="left-block">Observation & Comments</div>
                </div>
                <div class="content-body p-2 bg-white fixed-90h">
                  <p class="f-14">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
                </div>
              </div>
              <div style="width:60%;float:left;">
                <div class="box-header d-flex justify-content-between align-items-center">
                  <div class="left-block">Average Performance</div>
                </div>
                <div class="content-body p-2 bg-white fixed-90h">
                  <p class="f-14">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
                </div>
              </div>
            </div>
            <div class="border-box mt-1 w-100">
              <div class="box-header d-flex justify-content-between align-items-center">
                <div class="left-block blue-txt">Recommandation</div>
              </div>
              <div class="content-body p-2 bg-white pr-3 recomdation-box">
                <v-row class="justify-content-end no-gutters align-items-center">
                  <v-col sm="6">
                    <v-radio-group class="mt-0">
                      <v-row>
                        <v-col sm="6">
                          <v-radio label="Another Interview"
                                   value="radio-1"></v-radio>
                          <v-radio label="Retain"
                                   value="radio-2"></v-radio>
                        </v-col>
                        <v-col sm="6">
                          <v-radio label="Pending"
                                   value="radio-3"></v-radio>
                          <v-radio label="Reject"
                                   value="radio-4"></v-radio>
                        </v-col>
                      </v-row>
                    </v-radio-group>
                  </v-col>
                  <v-col sm="3" class="d-flex justify-content-end"><button class="btn blue-btn save-btn-blue round-btn d-flex align-items-center"><img src="../../../static/images/save-white.png" class="w-12 mr-1">Save</button></v-col>
                </v-row>
              </div>
            </div>
          </div>
          <div class="table-right-col">
            <div class="owl-carousel owl-theme main-slider">
              <div class="item">
                <div class="left-blank-space date-header">2020/10/15 (Wendy Luk)</div>
                <v-simple-table class="table table-sm mb-0 table-striped interview-table">
                  <template>
                    <thead>
                      <tr>
                        <th width="16%" class="text-center">
                          Exe
                        </th>
                        <th width="16%" class="text-center">
                          Good
                        </th>
                        <th width="16%" class="text-center">
                          Sat
                        </th>
                        <th width="16%" class="text-center">
                          Fair
                        </th>
                        <th width="16%" class="text-center">
                          Poor
                        </th>
                        <th width="16%" class="text-center">
                          N/A
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                      </tr>
                      <tr>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                      </tr>
                      <tr>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                      </tr>
                      <tr>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                      </tr>
                      <tr>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                      </tr>
                      <tr>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                      </tr>
                      <tr>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                      </tr>
                      <tr>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                      </tr>
                      <tr>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                      </tr>
                      <tr>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                      </tr>
                      <tr>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                      </tr>
                      <tr>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <div class="border-box mt-2">
                  <div class="box-header d-flex justify-content-between align-items-center">
                    <div class="left-block">Average Performance</div>
                  </div>
                  <div class="content-body p-2 bg-white fixed-90h">
                    <p class="f-14">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
                  </div>
                </div>
                <div class="border-box mt-2 w-100">
                  <div class="box-header d-flex justify-content-between align-items-center">
                    <div class="left-block blue-txt">Recommandation</div>
                  </div>
                  <div class="content-body p-2 bg-white pr-3 recomdation-box">
                    <v-row class="justify-content-end no-gutters align-items-center">
                      <v-col sm="12">
                        <v-radio-group class="mt-0">
                          <v-row>
                            <v-col sm="6">
                              <v-radio label="Another Interview"
                                       value="radio-1"></v-radio>
                              <v-radio label="Retain"
                                       value="radio-2"></v-radio>
                            </v-col>
                            <v-col sm="6">
                              <v-radio label="Pending"
                                       value="radio-3"></v-radio>
                              <v-radio label="Reject"
                                       value="radio-4"></v-radio>
                            </v-col>
                          </v-row>
                        </v-radio-group>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="left-blank-space date-header">2020/10/16 (Andrew Lau)</div>
                <v-simple-table class="table table-sm mb-0 table-striped interview-table">
                  <template>
                    <thead>
                      <tr>
                        <th width="16%" class="text-center">
                          Exe
                        </th>
                        <th width="16%" class="text-center">
                          Good
                        </th>
                        <th width="16%" class="text-center">
                          Sat
                        </th>
                        <th width="16%" class="text-center">
                          Fair
                        </th>
                        <th width="16%" class="text-center">
                          Poor
                        </th>
                        <th width="16%" class="text-center">
                          N/A
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                      </tr>
                      <tr>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                      </tr>
                      <tr>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                      </tr>
                      <tr>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                      </tr>
                      <tr>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                      </tr>
                      <tr>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                      </tr>
                      <tr>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                      </tr>
                      <tr>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                      </tr>
                      <tr>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                      </tr>
                      <tr>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                      </tr>
                      <tr>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                      </tr>
                      <tr>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <div class="border-box mt-2">
                  <div class="box-header d-flex justify-content-between align-items-center">
                    <div class="left-block">Average Performance</div>
                  </div>
                  <div class="content-body p-2 bg-white fixed-90h">
                    <p class="f-14">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
                  </div>
                </div>
                <div class="border-box mt-2 w-100">
                  <div class="box-header d-flex justify-content-between align-items-center">
                    <div class="left-block blue-txt">Recommandation</div>
                  </div>
                  <div class="content-body p-2 bg-white pr-3 recomdation-box">
                    <v-row class="justify-content-end no-gutters align-items-center">
                      <v-col sm="12">
                        <v-radio-group class="mt-0">
                          <v-row>
                            <v-col sm="6">
                              <v-radio label="Another Interview"
                                       value="radio-1"></v-radio>
                              <v-radio label="Retain"
                                       value="radio-2"></v-radio>
                            </v-col>
                            <v-col sm="6">
                              <v-radio label="Pending"
                                       value="radio-3"></v-radio>
                              <v-radio label="Reject"
                                       value="radio-4"></v-radio>
                            </v-col>
                          </v-row>
                        </v-radio-group>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="left-blank-space date-header">2020/10/16 (Andrew Lau)</div>
                <v-simple-table class="table table-sm mb-0 table-striped interview-table">
                  <template>
                    <thead>
                      <tr>
                        <th width="16%" class="text-center">
                          Exe
                        </th>
                        <th width="16%" class="text-center">
                          Good
                        </th>
                        <th width="16%" class="text-center">
                          Sat
                        </th>
                        <th width="16%" class="text-center">
                          Fair
                        </th>
                        <th width="16%" class="text-center">
                          Poor
                        </th>
                        <th width="16%" class="text-center">
                          N/A
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                      </tr>
                      <tr>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                      </tr>
                      <tr>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                      </tr>
                      <tr>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                      </tr>
                      <tr>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                      </tr>
                      <tr>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                      </tr>
                      <tr>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                      </tr>
                      <tr>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                      </tr>
                      <tr>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                      </tr>
                      <tr>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                      </tr>
                      <tr>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                      </tr>
                      <tr>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                        <td width="16%" class="text-center">
                          <v-checkbox class="table-checkbox m-0 p-0"
                                      color="indigo darken-3"
                                      value="indigo darken-3"
                                      hide-details></v-checkbox>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <div class="border-box mt-2">
                  <div class="box-header d-flex justify-content-between align-items-center">
                    <div class="left-block">Average Performance</div>
                  </div>
                  <div class="content-body p-2 bg-white fixed-90h">
                    <p class="f-14">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
                  </div>
                </div>
                <div class="border-box mt-2 w-100">
                  <div class="box-header d-flex justify-content-between align-items-center">
                    <div class="left-block blue-txt">Recommandation</div>
                  </div>
                  <div class="content-body p-2 bg-white pr-3 recomdation-box">
                    <v-row class="justify-content-end no-gutters align-items-center">
                      <v-col sm="12">
                        <v-radio-group class="mt-0">
                          <v-row>
                            <v-col sm="6">
                              <v-radio label="Another Interview"
                                       value="radio-1"></v-radio>
                              <v-radio label="Retain"
                                       value="radio-2"></v-radio>
                            </v-col>
                            <v-col sm="6">
                              <v-radio label="Pending"
                                       value="radio-3"></v-radio>
                              <v-radio label="Reject"
                                       value="radio-4"></v-radio>
                            </v-col>
                          </v-row>
                        </v-radio-group>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="border-box mt-1 w-100 d-inline-block mt-2">
            <div class="box-header d-flex justify-content-between align-items-center">
              <div class="left-block blue-txt">Offer</div>
            </div>
            <div class="content-body p-2 bg-white">
              <v-row class="ptb-0 sm-gutters justify-content-between align-items-center">
                <v-col sm="3">
                  <label class="inputs-lbl mb-1" for="company">Position Offered</label>
                  <div class="d-flex align-items-center input-mb-0">
                    <v-text-field class="form-input"></v-text-field>
                    <button class="btn btn-transparent p-1"><img src="../../../static/images/search.png" class="w-14" /></button>
                  </div>
                </v-col>
                <v-col sm="2">
                  <label class="inputs-lbl mb-1" for="company">Commencement Date</label>
                  <date-picker placeholder="Date OF Birth"
                               lang="en"
                               type="date"
                               format="YYYY-MM-DD"></date-picker>
                </v-col>
                <v-col sm="2">
                  <label class="inputs-lbl mb-1" for="company">Basic Salary</label>
                  <v-row class="sm-gutters">
                    <v-col sm="4">
                      <v-text-field class="form-input"></v-text-field>
                    </v-col>
                    <v-col sm="8">
                      <b-form-select v-model="selectedCompany"
                                     :options="companyDataList"
                                     value-field="CompanyCode"
                                     size="sm"
                                     :text-field="'EngDesc'"></b-form-select>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col sm="2">
                  <label class="inputs-lbl mb-1" for="company">Basic Salary</label>
                  <v-row class="sm-gutters">
                    <v-col sm="4">
                      <v-text-field class="form-input"></v-text-field>
                    </v-col>
                    <v-col sm="8">
                      <b-form-select v-model="selectedCompany"
                                     :options="companyDataList"
                                     value-field="CompanyCode"
                                     size="sm"
                                     :text-field="'EngDesc'"></b-form-select>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col sm="2">
                  <v-row class="sm-gutters">
                    <v-col sm="12"> <button class="btn blue-btn-start sm-btns d-flex align-items-center" data-toggle="modal" data-target="#reject-reason"><img src="../../../static/images/plane.png" class="w-10 mr-1" />Submit for Management Approval</button></v-col>
                    <!--<v-col sm="6"> <button class="btn blue-btn-start sm-btns d-flex align-items-center"><img src="../../../static/images/tick.png" class="w-10 mr-1" />Approve</button></v-col>
                  <v-col sm="6"> <button class="btn green-btn-start sm-btns d-flex align-items-center"><img src="../../../static/images/plane.png" class="w-10 mr-1" />Make Offer</button></v-col>-->
                  </v-row>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Make Offer Modal Start -->
    <div class="modal fade" id="makeoffer" tabindex="-1" role="dialog" aria-labelledby="delete" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered mw-440" role="document">
        <div class="modal-content list-modal">
          <div class="modal-header position-relative justify-content-center h-auto p-3">
            <div><img src="../../../static/images/delete-icon.png" class="img-fluid w-54" alt="" /></div>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body p-0">
            <div class="p-3">
              <div class="confirm-msg"><strong>Are you sure</strong> to make offer to <strong>FAN BING BING?</strong></div>
              <v-row class="ptb-0 justify-content-end align-items-center mt-3">
                <v-col sm="12" class="mb-0">
                  <div class="d-flex align-items-center justify-content-end mt-3">
                    <button class="btn btn-transparent round-btn md-btn weight-600">Cancel</button>
                    <button class="btn blue-btn round-btn ml-1 md-btn weight-600">Yes</button>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Make Offer Modal End -->
    <!-- Reject Modal Start -->
    <div class="modal fade" id="reject" tabindex="-1" role="dialog" aria-labelledby="delete" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered mw-440" role="document">
        <div class="modal-content list-modal">
          <div class="modal-header position-relative justify-content-center h-auto p-3">
            <div><img src="../../../static/images/delete-icon.png" class="img-fluid w-54" alt="" /></div>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body p-0">
            <div class="p-3">
              <div class="confirm-msg"><strong>Are you sure</strong> to reject <strong>FAN BING BING?</strong></div>
              <v-row class="ptb-0 justify-content-end align-items-center mt-3">
                <v-col sm="12" class="mb-0">
                  <div class="d-flex align-items-center justify-content-end mt-3">
                    <button class="btn btn-transparent round-btn md-btn weight-600">Cancel</button>
                    <button class="btn blue-btn round-btn ml-1 md-btn weight-600">Yes</button>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Reject Modal End -->
    <!-- Reject Reason Modal Start -->
    <div class="modal fade" id="reject-reason" tabindex="-1" role="dialog" aria-labelledby="delete" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered mw-440" role="document">
        <div class="modal-content list-modal">
          <div class="modal-header position-relative justify-content-center h-auto p-3">
            <div><img src="../../../static/images/write.png" class="img-fluid w-54" alt="" /></div>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body p-0">
            <div class="p-3">
              <div class="confirm-msg text-center"><strong>Please enter reject reason.</strong></div>
              <v-textarea solo class="form-textarea mt-2 resnson-area"
                          name="input-7-4" placeholder="reason"></v-textarea>
              <v-row class="ptb-0 justify-content-end align-items-center mt-3">
                <v-col sm="12" class="mb-0">
                  <div class="d-flex align-items-center justify-content-end mt-3">
                    <button class="btn btn-transparent round-btn md-btn weight-600">Cancel</button>
                    <button class="btn blue-btn round-btn ml-1 md-btn weight-600">Submit</button>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Reject Reason Modal End -->
  </div>
</template>


<script>
  import moment from 'moment';
  import DatePicker from "vue2-datepicker";
  export default {
    data() {
      return {
        model: null
      }
    },
    components: {
      DatePicker
    },
    data: () => ({
      selectedCompany: "",
      companyDataList: [{ "CompanyCode": "TYPHOON10", "EngDesc": "Typhoon 10", "ChiDesc": "10號颱風" }, { "CompanyCode": "TYPHOON03", "EngDesc": "Typhoon 3", "ChiDesc": "3號颱風", "AddBy": "", "DateAdd": "\/Date(1608721418425+0800)\/", "ModifyBy": "", "DateModify": "\/Date(-2209017600000+0800)\/", "RecDel": false }, { "WeatherCode": "TYPHOON08", "EngDesc": "Typhoon 8", "ChiDesc": "8號颱風", "AddBy": "", "DateAdd": "\/Date(1608721418425+0800)\/", "ModifyBy": "", "DateModify": "\/Date(-2209017600000+0800)\/", "RecDel": false }, { "WeatherCode": "DRIZZLE", "EngDesc": "Drizzle", "ChiDesc": "Drizzle", "AddBy": "", "DateAdd": "\/Date(1608721418425+0800)\/", "ModifyBy": "", "DateModify": "\/Date(-2209017600000+0800)\/", "RecDel": false }, { "WeatherCode": "SNOW", "EngDesc": "Snow", "ChiDesc": "Snow", "AddBy": "", "DateAdd": "\/Date(1608721418425+0800)\/", "ModifyBy": "", "DateModify": "\/Date(-2209017600000+0800)\/", "RecDel": false }, { "WeatherCode": "THUNDERSTORM", "EngDesc": "Thunderstorm", "ChiDesc": "Thunderstorm", "AddBy": "", "DateAdd": "\/Date(1608721418425+0800)\/", "ModifyBy": "", "DateModify": "\/Date(-2209017600000+0800)\/", "RecDel": false }, { "WeatherCode": "RAIN", "EngDesc": "Raining", "ChiDesc": "下雨天", "AddBy": "", "DateAdd": "\/Date(1608721418425+0800)\/", "ModifyBy": "", "DateModify": "\/Date(-2209017600000+0800)\/", "RecDel": false }, { "WeatherCode": "CLOUDS", "EngDesc": "多雲", "ChiDesc": "多雲", "AddBy": "", "DateAdd": "\/Date(1608721418425+0800)\/", "ModifyBy": "", "DateModify": "\/Date(-2209017600000+0800)\/", "RecDel": false }, { "WeatherCode": "SUNNY", "EngDesc": "Sunny", "ChiDesc": "天晴", "AddBy": "", "DateAdd": "\/Date(1608721418425+0800)\/", "ModifyBy": "", "DateModify": "\/Date(-2209017600000+0800)\/", "RecDel": false }, { "WeatherCode": "CLOUDY", "EngDesc": "Cloudy", "ChiDesc": "密雲", "AddBy": "", "DateAdd": "\/Date(1608721418425+0800)\/", "ModifyBy": "", "DateModify": "\/Date(-2209017600000+0800)\/", "RecDel": false }, { "WeatherCode": "RAINS", "EngDesc": "小雨", "ChiDesc": "小雨", "AddBy": "", "DateAdd": "\/Date(1608721418425+0800)\/", "ModifyBy": "", "DateModify": "\/Date(-2209017600000+0800)\/", "RecDel": false }, { "WeatherCode": "CLEAR", "EngDesc": "晴", "ChiDesc": "晴", "AddBy": "", "DateAdd": "\/Date(1608721418425+0800)\/", "ModifyBy": "", "DateModify": "\/Date(-2209017600000+0800)\/", "RecDel": false }, { "WeatherCode": "REDRAIN", "EngDesc": "Red rain storm", "ChiDesc": "紅雨", "AddBy": "", "DateAdd": "\/Date(1608721418425+0800)\/", "ModifyBy": "", "DateModify": "\/Date(-2209017600000+0800)\/", "RecDel": false }, { "WeatherCode": "THUNDER", "EngDesc": "Thundering", "ChiDesc": "雷暴", "AddBy": "", "DateAdd": "\/Date(1608721418425+0800)\/", "ModifyBy": "", "DateModify": "\/Date(-2209017600000+0800)\/", "RecDel": false }, { "WeatherCode": "YLWRAIN", "EngDesc": "Yellow rain storm", "ChiDesc": "黃雨", "AddBy": "", "DateAdd": "\/Date(1608721418425+0800)\/", "ModifyBy": "", "DateModify": "\/Date(-2209017600000+0800)\/", "RecDel": false }, { "WeatherCode": "BLKRAIN", "EngDesc": "Black rain storm", "ChiDesc": "黑雨", "AddBy": "", "DateAdd": "\/Date(1608721418425+0800)\/", "ModifyBy": "", "DateModify": "\/Date(-2209017600000+0800)\/", "RecDel": false }],
      tab: null,
      tabItems: [
        { tab: 'One', content: 'Tab 1 Content' },
        { tab: 'Two', content: 'Tab 2 Content' },
        { tab: 'Three', content: 'Tab 3 Content' },
        { tab: 'Four', content: 'Tab 4 Content' },
        { tab: 'Five', content: 'Tab 5 Content' },
        { tab: 'Six', content: 'Tab 6 Content' },
        { tab: 'Seven', content: 'Tab 7 Content' },
      ],
      tab1: null,
      tabItems: [
        { tab1: 'One', content: 'Tab 1 Content' },
        { tab1: 'Two', content: 'Tab 2 Content' },
        { tab1: 'Three', content: 'Tab 3 Content' },
        { tab1: 'Four', content: 'Tab 4 Content' },
        { tab1: 'Five', content: 'Tab 5 Content' },
        { tab1: 'Six', content: 'Tab 6 Content' },
        { tab1: 'Seven', content: 'Tab 7 Content' },
      ],
      items: [
        {
          id: 1,
          name: 'Apple Wong',
          children: [
            { id: 2, name: 'Eason Chan' },
            { id: 3, name: 'Eason Chan' },
            { id: 4, name: 'Eason Chan' },
          ],
        },
        {
          id: 5,
          name: 'Apple Wong',
          children: [
            {
              id: 6,
              name: 'Apple Wong',
              children: [
                {
                  id: 7,
                  name: 'src :',
                  children: [
                    { id: 8, name: 'Eason Chan' },
                    { id: 9, name: 'Eason Chan' },
                  ],
                },
              ],
            },
            {
              id: 10,
              name: 'Apple Wong',
              children: [
                {
                  id: 11,
                  name: 'src :',
                  children: [
                    { id: 12, name: 'Eason Chan' },
                    { id: 13, name: 'Eason Chan' },
                    { id: 14, name: 'Eason Chan' },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: 15,
          name: 'Apple Wong',
          children: [
            { id: 16, name: 'Eason Chan' },
            { id: 17, name: 'Eason Chan' },
            { id: 18, name: 'Eason Chan' },
          ],
        },
        {
          id: 19,
          name: 'Apple Wong',
          children: [
            {
              id: 20,
              name: 'Apple Wong',
              children: [
                { id: 21, name: 'Eason Chan' },
                { id: 22, name: 'Eason Chan' },
                { id: 23, name: 'Eason Chan' },
              ],
            },
            { id: 24, name: 'Eason Chan' },
            { id: 25, name: 'Eason Chan' },
          ],
        },
      ],

      files: {
        html: 'mdi-language-html5',
        js: 'mdi-nodejs',
        json: 'mdi-code-json',
        md: 'mdi-language-markdown',
        pdf: 'mdi-file-pdf',
        png: 'mdi-file-image',
        txt: 'mdi-file-document-outline',
        xls: 'mdi-file-excel',
      },
      tree: [],
      Documents: [
        {
          name: '',
          children: [
            {
              name: '12414',
            },
            {
              name: 'Untitled',
            },
          ],
        },
      ],
      date: new Date(),
      min: new Date(),
      max: new Date(),
      type: 'date'
    }),
    computed: {
      formattedDate() {
        return this.date &&
          moment(this.date).format('YYYY-MM-DD') != '1900-01-01'
          ? moment(this.date).format('YYYY-MM-DD')
          : undefined;
      },
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.tableSlider();
      },
      tableSlider: function () {
        setTimeout(function () {
          $('.main-slider').owlCarousel({
            loop: false,
            nav: true,
            center: false,
            autoplay: false,
            margin: 5,
            responsiveClass: true,
            navText: ["<img src='../../../static/images/left-arrow-black-triangle.png' class='w-8'>", "<img src='../../../static/images/right-arrow-black-triangle.png' class='w-8'>"],
            responsive: {
              600: {
                items: 1,
                nav: true
              },
              1000: {
                items: 2,
                nav: true
              },
              1400: {
                items: 2,
                nav: true
              }
            }
          });
        }, 300);
      },
    }
  };
</script>




// WEBPACK FOOTER //
// src/components/S110000-InterviewSchedule/S110100-InterviewScheduleOld.vue